import * as Modals from 'fw/globals/Modals'

let list = [];
let nextId = 0;

const get = (form) => {
	return list.filter(function (e) { return e.form.formId === form.formId; })[0];
}

export const add = (form) => {
	nextId++;
	form.formId = nextId;

	list.push({
		form: form,
		dirty: false
	});
}

export const remove = (form) => {
	list.some(function (e, index) {
		if (e.form.formId === form.formId) {
			list.splice(index, 1);
			return true;
		}

		return false;
	})
}

export const dirt = (form) => {
	get(form).dirty = true;
}

export const reset = () => {
	list.forEach(function (e, index) {
		e.dirty = false;
	});
}

export const checkUnsavedChanges = (callback) => {
	let r = false;

	// Look for dirty f	orms
	list.some(function (e) {
		if (e.dirty) { r = true; }
		return false;
	})

	// No unsaved changes? Or user chose to continue? Then do the callback...
	if (!r) {
		callback();
		return;
	}

	// There are changes, ask...
	Modals.unsaved("You have unsaved changes on this page. Those changes will be lost if you proceed.<br /><br />If you wish to save your changes, please select No and you will be returned to the previous screen.<br /><br /> If you wish to Discard your changes, select Yes.", function () {
		reset();
		callback();
	});
}



// WEBPACK FOOTER //
// ./src/fw/forms/form/FormManager.js